export default "__VITE_PUBLIC_ASSET__46a870d3__"